var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 13.8672C1.66406 13.1484 2.14062 11.6406 1.77344 10.7578C1.40625 9.875 0 9.10156 0 8.125C0 7.14844 1.39062 6.40625 1.77344 5.49219C2.15625 4.57813 1.66406 3.10156 2.38281 2.38281C3.10156 1.66406 4.60938 2.14062 5.49219 1.77344C6.375 1.40625 7.14844 0 8.125 0C9.10156 0 9.84375 1.39062 10.7578 1.77344C11.6719 2.15625 13.1484 1.66406 13.8672 2.38281C14.5859 3.10156 14.1094 4.60938 14.4766 5.49219C14.8438 6.375 16.25 7.14844 16.25 8.125C16.25 9.10156 14.8594 9.84375 14.4766 10.7578C14.0938 11.6719 14.5859 13.1484 13.8672 13.8672C13.1484 14.5859 11.6406 14.1094 10.7578 14.4766C9.875 14.8438 9.10156 16.25 8.125 16.25C7.14844 16.25 6.40625 14.8594 5.49219 14.4766C4.57813 14.0938 3.10156 14.5859 2.38281 13.8672Z",
    fill: "#4BA5EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 6.25L6.97656 10.625L4.6875 8.4375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedTick);
export default __webpack_public_path__ + "static/media/verified-tick.bb90b655c977334c8c8c74456d1bdd89.svg";
export { ForwardRef as ReactComponent };